module.exports = __webpack_public_path__ + "img/cj03.267b1c4a.jpg";